import type { SummaryCard } from '../../types';
import styles from './SummaryCards.module.css';

interface Props {
  cards: SummaryCard[];
}

export function SummaryCards({ cards }: Props) {
  return (
    <div className={styles.grid}>
      {cards.map((card, i) => (
        <div key={i} className={styles.card}>
          <div className={styles.accent} style={{ background: card.accent }} />
          <div className={styles.label}>{card.label}</div>
          <div className={styles.value}>{card.value}</div>
          <div className={styles.sub}>{card.sub}</div>
        </div>
      ))}
    </div>
  );
}
